(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-88"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() {
      document.querySelectorAll('[data-footer-88-col]').forEach(function (d) {
        d.open = !mq.matches || d.hasAttribute('data-footer-88-open');
      });
    }
    sync();
    if (mq.addEventListener) { mq.addEventListener('change', sync); } else if (mq.addListener) { mq.addListener(sync); }
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('[data-footer-88-col] > summary');
      if (summary && !mq.matches) { e.preventDefault(); return; }
      var a = e.target.closest('[data-footer-88-link]');
      if (!a) return;
      var data = {
        link_text: (a.getAttribute('aria-label') || a.textContent || '').trim(),
        link_url: a.href,
        link_group: a.getAttribute('data-footer-88-link')
      };
      try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') { Shopify.analytics.publish('footer_link_click', data); } } catch (err) {}
      try { if (typeof window.gtag === 'function') { window.gtag('event', 'footer_link_click', data); } } catch (err) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingr-explorer-88"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ingr-tabs-88')) {
    customElements.define('ingr-tabs-88', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, true));
          tab.addEventListener('keydown', (e) => {
            let n = null;
            if (e.key === 'ArrowRight') n = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') n = 0;
            if (e.key === 'End') n = this.tabs.length - 1;
            if (n !== null) { e.preventDefault(); this.select(n, true); this.tabs[n].focus(); }
          });
        });
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.findIndex((t) => t.getAttribute('aria-controls') === 'xp-panel-' + e.detail.blockId);
          if (i > -1) this.select(i, false);
        });
        this.querySelectorAll('.xp-88__cta').forEach((a) => a.addEventListener('click', () => {
          if (typeof window.gtag === 'function') window.gtag('event', 'ingredient_cta', { line: a.dataset.line || '' });
        }));
      }
      select(i, track) {
        this.tabs.forEach((t, j) => {
          const on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (track && typeof window.gtag === 'function') window.gtag('event', 'ingredient_tab', { line: this.tabs[i].dataset.name || '' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
